import { OrganizationUserRole } from "db/enums"
import type { GetCurrentUserResult } from "../queries/getCurrentUser"

/** Roles with school-admin permissions (Beheerder + Kartrekker). */
export const SCHOOL_ADMIN_ROLES = [
  "MANAGER",
  "INITIATOR",
] as const satisfies readonly OrganizationUserRole[]

export type SchoolAdminRole = (typeof SCHOOL_ADMIN_ROLES)[number]

type CurrentUserSchoolAdminArgs = {
  currentUser?: GetCurrentUserResult
  organizationId?: number | null
}

export function isSchoolAdminRole(
  role: OrganizationUserRole | null | undefined
): role is SchoolAdminRole
export function isSchoolAdminRole(args: CurrentUserSchoolAdminArgs): boolean
export function isSchoolAdminRole(
  roleOrArgs:
    | OrganizationUserRole
    | null
    | undefined
    | CurrentUserSchoolAdminArgs
): boolean {
  if (roleOrArgs != null && typeof roleOrArgs === "object") {
    const { currentUser, organizationId } = roleOrArgs
    if (
      !currentUser ||
      !organizationId ||
      !currentUser.organizationUsers ||
      currentUser.organizationUsers.length === 0
    ) {
      return false
    }

    const currentOrganizationUser = currentUser.organizationUsers.filter(
      (oU) => oU.organizationId === organizationId
    )
    if (currentOrganizationUser.length !== 1) {
      return false
    }

    return (
      currentOrganizationUser[0].role === "MANAGER" ||
      currentOrganizationUser[0].role === "INITIATOR"
    )
  }

  return roleOrArgs === "MANAGER" || roleOrArgs === "INITIATOR"
}
